import { Base64 } from "js-base64";
export default {
	// 获取登录状态
	loginType(_this) {
		_this.user = _this.$store.state.user;
		if (_this.$store.state.user) {
			if (_this.user.token == "") {
				_this.login = true;
			} else {
				_this.login = false;
			}
		} else {
			_this.login = true;
		}
	},
	// 获取头尾公共信息
	async getCommonInfo(_this, callback) {
		let common_info = _this.$store.state.common_info;

		if (common_info) {
			_this.common_info = common_info;
			if (callback) {
				callback();
			}
		} else {
			await _this.$api.common().then((res) => {
				if (res.code == 0) {
					_this.$store.commit("commonInfo", res.data);
					_this.common_info = res.data;
					if (callback) {
						callback();
					}
				}
			}).catch((err) => {
				this.message(_this, err)
			});
		}
	},
	// 进入个人中心
	toPersonal(_this) {
		_this.user = _this.$store.state.user;
		if (_this.$store.state.user) {
			if (_this.user.token != "") {
				_this.$router.push("/ttshop_user");
			} else {
				_this.$router.push("/signin");
			}
		} else {
			_this.$router.push("/signin");
		}
	},
	// 退出登录
	signout(_this) {
		let _that = _this;
		_this.$api.loginout().then((res) => {
				window.localStorage.removeItem('userInfo');
				_that.$store.commit("userInfo", '');
				_that.user = "";
				_that.login = true;
				var keys = document.cookie.match(/[^ =;]+(?==)/g)
				if (keys) {
					for (var i = 0; i < keys.length; i++) {
						document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
						document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
						document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
					}
					// document.cookie.split(";").forEach((c)=>{
					// 	document.cookie=c.replace(/^+/,'').replace(/=.*/,`=;expires=${new Date().toUTCString()};path=/`)
					// })
				}
				setTimeout(function () {
					_that.fullscreenLoading=false
					_that.$router.push("/");
					window.location.reload();
				}, 1000)
		}).catch((err) => {
			console.log(err)
		})

	},
	// 报错信息提示
	message(_this, error, callback) {
		_this.$loading().close();
		_this.$message({
			showClose: true,
			message: error.msg,
			type: "warning",
			offset: 200,
			duration: 1000,
		});
		if (callback) {
			callback();
		}
	},
	// 页面返回顶部
	backTop(time) {
		if (!time) {
			time = 5;
		}
		let timeFun = setInterval(() => {
			let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
			let ispeed = Math.floor(-scroll_top / 5);
			document.documentElement.scrollTop = document.body.scrollTop = scroll_top + ispeed;
			// this.isTop = true;
			if (scroll_top === 0) {
				clearInterval(timeFun);
			}
		}, time)
	},
	webService(_this, goods, store, type, customer_service) {
		let url_str = '';
		if (store.option) {
			url_str = decodeURIComponent(store.option.web_service_url);
		}
		if (type == 'mch') {
			url_str = decodeURIComponent(customer_service)
		}
		let user_info = _this.$store.state.user;
		let access_token = _this.$store.state.user.access_token;
		url_str = url_str.replace("visiter_id=", "visiter_id=" + user_info.id)
		url_str = url_str.replace("visiter_name=", "visiter_name=" + user_info.nickname)
		url_str = url_str.replace("avatar=", "avatar=" + user_info.avatar_url)
		let mobile_url = '';
		let pc_url = '';
		let base_access_token = ""; //加密后的access_token
		let mch_id = 0;
		if (goods.id) {
			if (store.service_mobile) {
				mobile_url = encodeURIComponent(store.service_mobile + '/#/pages/goods/goods?id=' + goods.id)
			}
			if (store.service_pc) {
				pc_url = encodeURIComponent(store.service_pc + '/#/pages/goods/goods?id=' + goods.id)
			}
			let img = "";
			if (goods.pic_list) {
				if (goods.pic_list[0]) {
					img = goods.pic_list[0].pic_url
				}
			} else {
				if (goods.goods_pic_list && goods.goods_pic_list.length) {
					img = goods.goods_pic_list[0]
				}
			}
			base_access_token = Base64.encode(access_token);
			if (goods.mch) {
				mch_id = goods.mch.id;
			}
			let product = JSON.stringify({
				pid: goods.id,
				title: goods.name,
				img: img,
				info: goods.subtitle,
				price: goods.min_price,
				url: mobile_url,
				mobile_url: mobile_url,
				pc_url: pc_url,
				access_token: base_access_token,
				mch_id: mch_id
			});
			url_str += "&product=" + product
		}
		return url_str;
	}
}
